module.exports = __webpack_public_path__ + "img/C - 03.5cf4cf76.png";